import axios from 'axios';
import { AnalyticsService } from './analytics.service';
var HttpService = /** @class */ (function () {
    function HttpService() {
        this.analyticsService = new AnalyticsService();
        this.defaultHeaders = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest',
                'Analytics-User': this.analyticsService.getDtmVisitorID()
            }
        };
        this.baseUrl = '/';
        this.http = axios.create({
            baseURL: this.baseUrl
        });
    }
    HttpService.getInstance = function () {
        if (!HttpService.instance) {
            HttpService.instance = new HttpService();
        }
        return HttpService.instance;
    };
    HttpService.prototype.get = function (url) {
        return this.http.get(url);
    };
    HttpService.prototype.post = function (url, config) {
        return this.http.post(url);
    };
    HttpService.prototype.postHeaders = function (pUrl, pFields, pHeaders) {
        if (pHeaders === void 0) { pHeaders = null; }
        var results = axios.post(pUrl, pFields, (pHeaders ? pHeaders : this.defaultHeaders)).then(function (response) {
            // service ok
            return response;
        }).catch(function (response) {
            // service failed
            return response;
        });
        return results;
    };
    HttpService.prototype.getHeaders = function (pUrl, pHeaders) {
        if (pHeaders === void 0) { pHeaders = null; }
        var results = axios.get(pUrl, (pHeaders ? pHeaders : this.defaultHeaders)).then(function (response) {
            // service ok
            return response;
        }).catch(function (response) {
            // service failed
            return response;
        });
        return results;
    };
    HttpService.prototype.serialiseObject = function (pObject, pParent) {
        if (pParent === void 0) { pParent = ""; }
        // return Object.keys(pObject).reduce(function (a, k) { a.push(k + '=' + encodeURIComponent(pObject[k])); return a }, []).join('&')
        if (typeof pObject !== "object") {
            if (typeof console !== "undefined") {
                console.log("pObject is not a JSON object");
                return null;
            }
        }
        var u = encodeURIComponent;
        var urlJson = "";
        var keys = Object.keys(pObject);
        for (var i = 0; i < keys.length; i++) {
            var k = pParent ? pParent + "[" + keys[i] + "]" : keys[i];
            if (pObject[keys[i]]) {
                if (typeof pObject[keys[i]] !== "object") {
                    urlJson += u(k) + "=" + u(pObject[keys[i]]);
                }
                else {
                    urlJson += this.serialiseObject(pObject[keys[i]], k);
                }
            }
            else {
                urlJson += u(k) + "=" + u(pObject[keys[i]]);
            }
            if (i < (keys.length - 1)) {
                urlJson += "&";
            }
        }
        return urlJson;
    };
    return HttpService;
}());
export { HttpService };



//////////////////
// WEBPACK FOOTER
// ./services/http.service.ts
// module id = 19
// module chunks = 0